import { render, staticRenderFns } from "./ques1.vue?vue&type=template&id=26f31282"
import script from "./ques1.vue?vue&type=script&lang=js"
export * from "./ques1.vue?vue&type=script&lang=js"
import style0 from "./ques1.vue?vue&type=style&index=0&id=26f31282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports